/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export function Icon3Icon(props) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      version={"1.1"}
      viewBox={"0 0 600 775"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"#fff"}
        d={
          "M300 0C134.31 0 0 134.32 0 300v550h175V300c0-69.03 55.96-125 125-125s125 55.97 125 125-55.97 125-125 125c-34.59 0-65.9-14.04-88.53-36.75v198.48C239.46 595.35 269.19 600 300 600c165.68 0 300-134.31 300-300S465.68 0 300 0"
        }
      ></path>
    </svg>
  );
}

export default Icon3Icon;
/* prettier-ignore-end */
